module.exports = "pegasus/assets/blocks/column-10-theme3.png";